import React from 'react';
import { ProjectRecruitingView } from '../../components/projectWorkspace/ProjectRecruitingView';

export const ProjectPipelineContainer = () => <ProjectRecruitingView mode="board" />;
